var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject, computedFrom } from "aurelia-framework";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { I18N } from "aurelia-i18n";
import { ValidationControllerFactory, validateTrigger, ValidationRules } from "aurelia-validation";
import { NotificationType, NotificationClientService } from "../../../../services/basics/notification-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { EntityTypes } from "../../../../models/basics/basics.models";
import { DialogServiceConstants } from "../../../../../../ClientApp/app/constants/basics/dialog.constants";
var ActivityAssignment = /** @class */ (function (_super) {
    __extends(ActivityAssignment, _super);
    function ActivityAssignment(dialogClientService, i18N, workflowAssignmentsService, validationControllerFactory, notificationService, tokenClient) {
        var _this = _super.call(this, dialogClientService, i18N, workflowAssignmentsService) || this;
        _this.notificationService = notificationService;
        _this.tokenClient = tokenClient;
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(ActivityAssignment.prototype, "insurancePayoutPolicyDeductionVisible", {
        get: function () {
            return this.entityTypeId == EntityTypes.WinningNominationClaim;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityAssignment.prototype, "remarks", {
        get: function () {
            return this.assignment ? this.assignment.remarks : null;
        },
        set: function (x) {
            if (this.assignment)
                this.assignment.remarks = x;
        },
        enumerable: false,
        configurable: true
    });
    ActivityAssignment.prototype.isOperatorAdminOrBrandAdmin = function () {
        return this.tokenClient.isOperatorAdmin() || this.tokenClient.isBrandAdmin();
    };
    ActivityAssignment.prototype.onActivated = function () {
        var _this = this;
        this.configMeta = JSON.parse(this.assignment.configMeta);
        if (this.assignment.meta) {
            var meta = JSON.parse(this.assignment.meta);
            this.insurancePayoutPolicyDeduction = meta.insurancePayoutPolicyDeduction ? meta.insurancePayoutPolicyDeduction : this.configMeta.insurancePayoutPolicyDeduction;
            this.euroRate = meta.euroRate ? meta.euroRate : this.configMeta.euroRate;
            this.winningAmountToClaim = meta.winningAmountToClaim ? meta.winningAmountToClaim : this.configMeta.winningAmountToClaim;
        }
        else {
            this.insurancePayoutPolicyDeduction = this.configMeta.insurancePayoutPolicyDeduction;
            this.euroRate = this.configMeta.euroRate;
            this.winningAmountToClaim = this.configMeta.winningAmountToClaim;
        }
        this.rules = ValidationRules
            .ensure(function (x) { return x.winningAmountToClaim; }).required().withMessage("Winning amount to claim is required.")
            .ensure(function (x) { return x.euroRate; }).required().withMessage("Euro rate is required.")
            .ensure(function (x) { return x.remarks; }).satisfies(function () {
            // if some of the properties changed then the notes need to be filled 
            if (!_this.remarks && (_this.euroRate != _this.configMeta.euroRate
                || _this.winningAmountToClaim != _this.configMeta.winningAmountToClaim
                || _this.insurancePayoutPolicyDeduction != _this.configMeta.insurancePayoutPolicyDeduction)) {
                return false;
            }
            return true;
        }).withMessage("Remarks need to be filled.")
            .on(this)
            .rules;
    };
    ActivityAssignment.prototype.submit = function () {
        return this.accept();
    };
    ActivityAssignment.prototype.accept = function () {
        var _this = this;
        this.controller
            .validate({ object: this, rules: this.rules })
            .then(function (x) {
            if (x.valid) {
                askForConfirmationAndExecute();
            }
            else {
                var errors = _this.controller.errors.map(function (x) { return x.message; }).join("\n");
                _this.notificationService.show(_this.i18N.tr("validation-error"), errors, NotificationType.Error);
            }
        });
        var askForConfirmationAndExecute = function () {
            require("../../../../../../ClientApp/app/views/app/admin/dialogs/confirmation-dialog");
            var confirmModel = {
                headerTitle: "confirmation-title",
                headerMessage: "confirmation-accept-text",
                btnOkayText: "confirm-text",
                btnNoText: "cancel-text",
            };
            _this.dialogClientService.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                confirmModel: confirmModel,
                save: function () { return new Promise(function (resolve, reject) {
                    var insurancePayoutPolicyDeduction = _this.insurancePayoutPolicyDeduction != _this.configMeta.insurancePayoutPolicyDeduction ? _this.insurancePayoutPolicyDeduction : null;
                    var euroRate = _this.euroRate != _this.configMeta.euroRate ? _this.euroRate : null;
                    var winningAmountToClaim = _this.winningAmountToClaim != _this.configMeta.winningAmountToClaim ? _this.winningAmountToClaim : null;
                    var meta = JSON.stringify({
                        winningAmountToClaim: winningAmountToClaim,
                        euroRate: euroRate,
                        insurancePayoutPolicyDeduction: insurancePayoutPolicyDeduction
                    });
                    _this.workflowAssignmentsService
                        .executeAction(_this.assignment.workflowStateId, 'insurer-activity', 'accept', _this.assignment.workflowAssignmentId, null, _this.assignment.remarks, meta)
                        .then(function (response) {
                        _this.dialogClientService.hide();
                        _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("workflow-accepted-text"), NotificationType.Success);
                        _this.reload(response.workflowState);
                        resolve();
                    })
                        .catch(function () {
                        _this.dialogClientService.hide();
                        _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("generic-error-text"), NotificationType.Error);
                        reject();
                    });
                }); }
            }, undefined, undefined, undefined, undefined, false);
        };
    };
    ActivityAssignment.prototype.reject = function () {
        this.cancelWorkflow();
    };
    __decorate([
        computedFrom("assignment"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ActivityAssignment.prototype, "remarks", null);
    ActivityAssignment = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService,
            I18N,
            WorkflowAssignmentsService,
            ValidationControllerFactory,
            NotificationClientService,
            TokenClient])
    ], ActivityAssignment);
    return ActivityAssignment;
}(BaseWorkflowActivityAssignmentViewModel));
export { ActivityAssignment };
